import { combineReducers } from 'redux';

import currentAssignmentsModalReducer from '@components/current-assignment-modal/redux/reducer';
import toastReducer from '@components/toast/toast-reducer';
import UPFAssignReducer from '../upf-assign/upf-assign-reducer';
import ducsReducer from '../ducs/reducer';
import entitiesReducer from '../entities/entities-reducer';
import gatewaysReducer from '../gateways/gateways-reducer';
import modalContainerReducer from '../modal-manager/modal-manager-reducer';

const CombinedReducers = combineReducers({
  UPFAssignReducer,
  currentAssignmentsModalReducer,
  ducsReducer,
  entitiesReducer,
  gatewaysReducer,
  modalContainerReducer,
  product: state => ({ ...state }),
  toastReducer
});

export default CombinedReducers;



// WEBPACK FOOTER //
// ./containers/app/combined-reducers.js